import React, {Component} from 'react';
import {connect} from "react-redux";

class Checkbox extends Component {


    render() {
        return (
            <div className={"checkbox-material " + (this.props.className ? this.props.className : "")}>
                <input type="checkbox" id={this.props.id} checked={this.props.checked}
                       onChange={this.props.onChange}/>
                <label htmlFor={this.props.id}>
                    {this.props.label}
                </label>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkbox)
